import React, { useEffect, useRef } from 'react';

const shortcuts = [['c', 'toggle calculator'], ['n', 'new note at cursor'], ['backspace / delete', 'delete selected item'], ['ctrl / ⌘ + d', 'duplicate selected item'], ['ctrl / ⌘ + z', 'undo'], ['ctrl / ⌘ + shift + z / ctrl + y', 'redo'], ['ctrl / ⌘ + c / x / v', 'copy / cut / paste text or selected item'], ['f', 'fit all items in view'], ['0', 'reset zoom to 100%'], ['+ / −', 'zoom in / out'], ['g', 'toggle snap to grid'], ['escape', 'leave text editing / clear selection'], ['?', 'show keyboard help'], ['middle drag', 'pan the board'], ['ctrl + wheel', 'zoom at cursor'], ['arrow keys on handles', 'move / resize; shift for larger steps']];

const ShortcutHelp = function({open, onClose}) {
  const ref = useRef(null);

  useEffect(() => {
    if (open) ref.current.showModal();
    else ref.current.close();
  }, [open]);

  return <dialog
    ref={ref}
    className='shortcutHelp'
    onClose={onClose}
    onClick={event => {
      if (event.target === ref.current) onClose();
    }}
  >
      <div className='shortcutContent'>
        <div className='shortcutHeading h'><h2>keyboard & mouse</h2><button className='iconButton' aria-label='close help' onClick={onClose}>×</button></div>
        <p>shortcuts pause while you type. press escape to leave an editor.</p>
        <dl>{shortcuts.map(([key, action]) => <div key={key}><dt><kbd>{key}</kbd></dt><dd>{action}</dd></div>)}</dl>
      </div>
    </dialog>;
};

export default ShortcutHelp;
